import racingConfig from './racing/config';
import footballConfig from './football/config';

const sportTypeConfigs = {
    racing: racingConfig,
    football: footballConfig
};

// eslint-disable-next-line import/prefer-default-export
export const getSportTypeConfig = sportType => {
    return sportTypeConfigs[sportType] ?? racingConfig;
};
